// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import SaintKittsNevis from '../_raw/flag/icon_flag_saint_kitts_nevis.png';

export default () => <img src={SaintKittsNevis} alt="SaintKittsNevis" />;
